"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const logicCalc_1 = __importDefault(require("../lib/logicCalc"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('L', (context, args) => {
    return logicCalc_1.default(args[0], args[1], args[2]);
});
